<template>
    <section id="mobile-left-sidebar">
        <div class="left-sidebar-button d-flex justify-content-center align-items-center" @click="openBottomSheet()">
            <icon name="list" color="white" scale="1.2" />
        </div>
        <SwipeableBottomSheet ref="swipeableBottomSheet" search>
            <template v-slot:header>
                {{ $t('keyword65') }}
            </template>
            <template v-slot:content>
                <div class="content d-flex">
                    <vue-custom-scrollbar class="w-100 h-100">
                        <div v-if="project.map" class="map w-100" v-b-toggle.map-collapse>
                            <div class="name-grid w-100">
                                <div class="icon d-flex justify-content-center align-items-center">
                                    <icon name="map" color="white" />
                                </div>
                                <div class="map-name d-flex align-items-center">
                                    <h2>{{ $t('keyword49') }}</h2>
                                </div>
                            </div>
                            <b-collapse visible id="map-collapse">
                                <div v-if="project.map.sectors && project.map.sectors.length" class="sectors">
                                    <ul class="sectors-ul">
                                        <li v-for="sector in project.map.sectors" :key="'sector-' + sector.id">
                                            <div @click.stop="() => {}" class="sector w-100" v-b-toggle="'sector-' + sector.id">
                                                <div class="name-grid w-100">
                                                    <div class="icon d-flex justify-content-center align-items-center">
                                                        <icon
                                                            name="layer-group"
                                                            :color="
                                                                sector.id == currentSector.id && sector.floorplans && sector.floorplans.length > 0
                                                                    ? 'white'
                                                                    : sector.floorplans && sector.floorplans.length > 0
                                                                    ? 'var(--secondary)'
                                                                    : 'rgba(30, 179, 253, 0.5)'
                                                            "
                                                        />
                                                    </div>
                                                    <div class="sector-name d-flex align-items-center">
                                                        {{ sector.name }}
                                                    </div>
                                                </div>
                                                <b-collapse class="w-100" :accordion="'sector-' + sector.id" :id="'sector-' + sector.id">
                                                    <ul class="floorplans-ul" v-if="sector.floorplans && sector.floorplans.length">
                                                        <li v-for="floorplan in sector.floorplans" :key="'floorplan-' + floorplan.id">
                                                            <div @click.stop="() => {}" class="floorplan w-100" v-b-toggle="'floorplan-' + floorplan.id">
                                                                <div class="name-grid w-100">
                                                                    <div class="icon d-flex justify-content-center align-items-center">
                                                                        <icon
                                                                            name="ci-layer"
                                                                            :color="
                                                                                floorplan.id == currentFloorplan.id && floorplan.viewpoints.length > 0
                                                                                    ? 'white'
                                                                                    : floorplan.viewpoints.length > 0
                                                                                    ? 'var(--secondary)'
                                                                                    : 'rgba(30, 179, 253, 0.5)'
                                                                            "
                                                                        />
                                                                    </div>
                                                                    <div class="floorplan-name">
                                                                        {{ floorplan.name }}
                                                                    </div>
                                                                </div>
                                                                <b-collapse
                                                                    class="w-100"
                                                                    :accordion="'floorplan-' + floorplan.id"
                                                                    :id="'floorplan-' + floorplan.id"
                                                                >
                                                                    <ul class="viewpoints-ul" v-if="floorplan.viewpoints && floorplan.viewpoints.length">
                                                                        <li v-for="viewpoint in floorplan.viewpoints" :key="'viewpoint-' + viewpoint.id">
                                                                            <div @click="changeViewpoint(floorplan, viewpoint)" class="viewpoint w-100">
                                                                                <div class="name-grid w-100">
                                                                                    <div class="icon d-flex justify-content-center align-items-center">
                                                                                        <icon
                                                                                            name="ci-circle"
                                                                                            :color="
                                                                                                viewpoint.id == currentViewpoint.id
                                                                                                    ? 'white'
                                                                                                    : 'var(--secondary)'
                                                                                            "
                                                                                            scale=".5"
                                                                                        />
                                                                                    </div>
                                                                                    <div class="viewpoint-name">
                                                                                        {{ viewpoint.name }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                    <div v-else class="not-registered">
                                                                        {{ $t('Components_Viewer_LeftSidebar_7') }}
                                                                    </div>
                                                                </b-collapse>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <div v-else class="not-registered">
                                                        {{ $t('Components_Viewer_LeftSidebar_8') }}
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else-if="!project.map.sectors && !project.map.sectors.length" class="not-registered">
                                    {{ $t('Components_Viewer_LeftSidebar_9') }}
                                </div>
                                <div v-if="project.map.viewpoints && project.map.viewpoints.length" class="map-viewpoints">
                                    <ul class="viewpoints-ul">
                                        <li v-for="viewpoint in project.map.viewpoints" :key="'viewpoint-' + viewpoint.id">
                                            <div @click="changeViewpoint(project.map, viewpoint)" class="viewpoint w-100">
                                                <div class="name-grid w-100">
                                                    <div class="icon d-flex justify-content-center align-items-center">
                                                        <icon
                                                            name="ci-circle"
                                                            :color="viewpoint.id == currentViewpoint.id ? 'white' : 'var(--secondary)'"
                                                            scale=".5"
                                                        />
                                                    </div>
                                                    <div class="viewpoint-name">
                                                        {{ viewpoint.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </b-collapse>
                        </div>
                        <div v-else class="not-map-floorplans">
                            <ul class="floorplans-ul" v-if="project.floorplans && project.floorplans.length">
                                <li v-for="floorplan in project.floorplans" :key="'floorplan-' + floorplan.id">
                                    <div @click.stop="() => {}" class="floorplan w-100" v-b-toggle="'floorplan-' + floorplan.id">
                                        <div class="name-grid w-100">
                                            <div class="icon d-flex justify-content-center align-items-center">
                                                <icon
                                                    name="ci-layer"
                                                    :color="
                                                        floorplan.id == currentFloorplan.id && floorplan.viewpoints.length > 0
                                                            ? 'white'
                                                            : floorplan.viewpoints.length > 0
                                                            ? 'var(--secondary)'
                                                            : 'rgba(30, 179, 253, 0.5)'
                                                    "
                                                />
                                            </div>
                                            <div class="floorplan-name">
                                                {{ floorplan.name }}
                                            </div>
                                        </div>
                                        <b-collapse class="w-100" :accordion="'floorplan-' + floorplan.id" :id="'floorplan-' + floorplan.id">
                                            <ul class="viewpoints-ul" v-if="floorplan.viewpoints && floorplan.viewpoints.length">
                                                <li v-for="viewpoint in floorplan.viewpoints" :key="'viewpoint-' + viewpoint.id">
                                                    <div @click="changeViewpoint(floorplan, viewpoint)" class="viewpoint w-100">
                                                        <div class="name-grid w-100">
                                                            <div class="icon d-flex justify-content-center align-items-center">
                                                                <icon
                                                                    name="ci-circle"
                                                                    :color="viewpoint.id == currentViewpoint.id ? 'white' : 'var(--secondary)'"
                                                                    scale=".5"
                                                                />
                                                            </div>
                                                            <div class="viewpoint-name">
                                                                {{ viewpoint.name }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div v-else class="not-registered">
                                                {{ $t('Components_Viewer_LeftSidebar_7') }}
                                            </div>
                                        </b-collapse>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </vue-custom-scrollbar>
                </div>
            </template>
        </SwipeableBottomSheet>
    </section>
</template>

<script>
import 'vue-awesome/icons/list'
import 'vue-awesome/icons/map'
import 'vue-awesome/icons/layer-group'

import vueCustomScrollbar from 'vue-custom-scrollbar'
import SwipeableBottomSheet from '@/components/360Viewer/UI/Mobile/SwipeableBottomSheet'

/**
 * Summary.
 * Mobile list view for sectors and floorplans.
 *
 * @param {Object} currentSector
 * @param {Object} currentFloorplan
 * @param {Object} currentViewpoint
 * @param {Object} project
 *
 * @event onSelectViewpoint
 */

export default {
    components: {
        vueCustomScrollbar,
        SwipeableBottomSheet,
    },
    props: {
        currentSector: Object,
        currentFloorplan: Object,
        currentViewpoint: Object,
        project: Object,
    },
    methods: {
        openBottomSheet() {
            this.$refs.swipeableBottomSheet.setState('open')
        },
        changeViewpoint(fp, vp) {
            this.$emit('onSelectViewpoint', { fp, vp })

            this.$refs.swipeableBottomSheet.setState('close')
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/Mobile/floorplans-list.scss';
</style>
